import { type TileCoordinates } from "@/types/tile";
import AdvancedIronMineBuildingTileEntity from "../entities/buildings/AdvancedIronMineBuildingTileEntity";
import ApiaryBuildingTileEntity from "../entities/buildings/ApiaryBuildingTileEntity";
import ApothecaryBuildingTileEntity from "../entities/buildings/ApothecaryBuildingTileEntity";
import ArchersBuildingTileEntity from "../entities/buildings/ArchersBuildingTileEntity";
import ArcheryRangeBuildingTileEntity from "../entities/buildings/ArcheryRangeBuildingTileEntity";
import ArenaBuildingTileEntity from "../entities/buildings/ArenaBuildingTileEntity";
import ArmamentsTraderBuildingTileEntity from "../entities/buildings/ArmamentsTraderBuildingTileEntity";
import ArmoryBuildingTileEntity from "../entities/buildings/ArmoryBuildingTileEntity";
import ArtisanSmithBuildingTileEntity from "../entities/buildings/ArtisanSmithBuildingTileEntity";
import BakeryBuildingTileEntity from "../entities/buildings/BakeryBuildingTileEntity";
import BanquetBuildingTileEntity from "../entities/buildings/BanquetBuildingTileEntity";
import BarracksBuildingTileEntity from "../entities/buildings/BarracksBuildingTileEntity";
import BathHouseBuildingTileEntity from "../entities/buildings/BathHouseBuildingTileEntity";
import BigShipyardBuildingTileEntity from "../entities/buildings/BigShipyardBuildingTileEntity";
import BlacksmithBuildingTileEntity from "../entities/buildings/BlacksmithBuildingTileEntity";
import BottletrapBuildingTileEntity from "../entities/buildings/BottletrapBuildingTileEntity";
import BountifulMarketplaceBuildingTileEntity from "../entities/buildings/BountifulMarketplaceBuildingTileEntity";
import BreweryBuildingTileEntity from "../entities/buildings/BreweryBuildingTileEntity";
import BrickyardBuildingTileEntity from "../entities/buildings/BrickyardBuildingTileEntity";
import CandlemakerBuildingTileEntity from "../entities/buildings/CandlemakerBuildingTileEntity";
import CarpentryDistrictBuildingTileEntity from "../entities/buildings/CarpentryDistrictBuildingTileEntity";
import CattleRangeBuildingTileEntity from "../entities/buildings/CattleRangeBuildingTileEntity";
import CattleRangeSpecialBuildingTileEntity from "../entities/buildings/CattleRangeSpecialBuildingTileEntity";
import ClayPitBuildingTileEntity from "../entities/buildings/ClayPitBuildingTileEntity";
import CommandPostBuildingTileEntity from "../entities/buildings/CommandPostBuildingTileEntity";
import CorsairShipBuildingTileEntity from "../entities/buildings/CorsairShipBuildingTileEntity";
import CountryHouseBuildingTileEntity from "../entities/buildings/CountryHouseBuildingTileEntity";
import DarkwoodLumberMillBuildingTileEntity from "../entities/buildings/DarkwoodLumberMillBuildingTileEntity";
import DeepSeaBigFishingBoatBuildingTileEntity from "../entities/buildings/DeepSeaBigFishingBoatBuildingTileEntity";
import DeepSeaFishingBoatBuildingTileEntity from "../entities/buildings/DeepSeaFishingBoatBuildingTileEntity";
import DeepSeaPearlHunterBuildingTileEntity from "../entities/buildings/DeepSeaPearlHunterBuildingTileEntity";
import EnkindledHouseholdBuildingTileEntity from "../entities/buildings/EnkindledHouseholdBuildingTileEntity";
import FireFestivalPyreBuildingTileEntity from "../entities/buildings/FireFestivalPyreBuildingTileEntity";
import FishermansHutBuildingTileEntity from "../entities/buildings/FishermansHutBuildingTileEntity";
import FishingVillageBuildingTileEntity from "../entities/buildings/FishingVillageBuildingTileEntity";
import FletcherBuildingTileEntity from "../entities/buildings/FletcherBuildingTileEntity";
import FortressBuildingTileEntity from "../entities/buildings/FortressBuildingTileEntity";
import FoundryBuildingTileEntity from "../entities/buildings/FoundryBuildingTileEntity";
import FurnaceBuildingTileEntity from "../entities/buildings/FurnaceBuildingTileEntity";
import GatherersHutBuildingTileEntity from "../entities/buildings/GatherersHutBuildingTileEntity";
import GemsMineBuildingTileEntity from "../entities/buildings/GemsMineBuildingTileEntity";
import GoldMineBuildingTileEntity from "../entities/buildings/GoldMineBuildingTileEntity";
import GoldProspectorBuildingTileEntity from "../entities/buildings/GoldProspectorBuildingTileEntity";
import GuardTowerBuildingTileEntity from "../entities/buildings/GuardTowerBuildingTileEntity";
import HauntedMansionBuildingTileEntity from "../entities/buildings/HauntedMansionBuildingTileEntity";
import HealersHutBuildingTileEntity from "../entities/buildings/HealersHutBuildingTileEntity";
import HighlandHunterBuildingTileEntity from "../entities/buildings/HighlandHunterBuildingTileEntity";
import HillsBlastFurnaceBuildingTileEntity from "../entities/buildings/HillsBlastFurnaceBuildingTileEntity";
import HillsLookoutTowerBuildingTileEntity from "../entities/buildings/HillsLookoutTowerBuildingTileEntity";
import HillsScoutTowerBuildingTileEntity from "../entities/buildings/HillsScoutTowerBuildingTileEntity";
import HopsFieldBuildingTileEntity from "../entities/buildings/HopsFieldBuildingTileEntity";
import HuntersLodgeBuildingTileEntity from "../entities/buildings/HuntersLodgeBuildingTileEntity";
import HuntingCampBuildingTileEntity from "../entities/buildings/HuntingCampBuildingTileEntity";
import IndustrialFoundryBuildingTileEntity from "../entities/buildings/IndustrialFoundryBuildingTileEntity";
import IndustrialLumberMillBuildingTileEntity from "../entities/buildings/IndustrialLumberMillBuildingTileEntity";
import InnBuildingTileEntity from "../entities/buildings/InnBuildingTileEntity";
import IronMineBuildingTileEntity from "../entities/buildings/IronMineBuildingTileEntity";
import LargeBreweryBuildingTileEntity from "../entities/buildings/LargeBreweryBuildingTileEntity";
import LargeClayPitBuildingTileEntity from "../entities/buildings/LargeClayPitBuildingTileEntity";
import LargeHousesBuildingTileEntity from "../entities/buildings/LargeHousesBuildingTileEntity";
import LargeStoneQuarryBuildingTileEntity from "../entities/buildings/LargeStoneQuarryBuildingTileEntity";
import LightCavalryBuildingTileEntity from "../entities/buildings/LightCavalryBuildingTileEntity";
import LighthouseBuildingTileEntity from "../entities/buildings/LighthouseBuildingTileEntity";
import LivestockFarmBuildingTileEntity from "../entities/buildings/LivestockFarmBuildingTileEntity";
import LuckyCauldronBuildingTileEntity from "../entities/buildings/LuckyCauldronBuildingTileEntity";
import LumberMillBuildingTileEntity from "../entities/buildings/LumberMillBuildingTileEntity";
import ManorBuildingTileEntity from "../entities/buildings/ManorBuildingTileEntity";
import MarketBuildingTileEntity from "../entities/buildings/MarketBuildingTileEntity";
import MediumHousesBuildingTileEntity from "../entities/buildings/MediumHousesBuildingTileEntity";
import MilitaryAcademyBuildingTileEntity from "../entities/buildings/MilitaryAcademyBuildingTileEntity";
import MilitiaBuildingTileEntity from "../entities/buildings/MilitiaBuildingTileEntity";
import MillBuildingTileEntity from "../entities/buildings/MillBuildingTileEntity";
import MinstrelsPodiumBuildingTileEntity from "../entities/buildings/MinstrelsPodiumBuildingTileEntity";
import MintBuildingTileEntity from "../entities/buildings/MintBuildingTileEntity";
import MonolithCircleBuildingTileEntity from "../entities/buildings/MonolithCircleBuildingTileEntity";
import MountainBellowsBuildingTileEntity from "../entities/buildings/MountainBellowsBuildingTileEntity";
import MountainsBlastFurnaceBuildingTileEntity from "../entities/buildings/MountainsBlastFurnaceBuildingTileEntity";
import MountainsLookoutTowerBuildingTileEntity from "../entities/buildings/MountainsLookoutTowerBuildingTileEntity";
import MountainsScoutTowerBuildingTileEntity from "../entities/buildings/MountainsScoutTowerBuildingTileEntity";
import OutpostBuildingTileEntity from "../entities/buildings/OutpostBuildingTileEntity";
import OxenStableBuildingTileEntity from "../entities/buildings/OxenStableBuildingTileEntity";
import PatisserieBuildingTileEntity from "../entities/buildings/PatisserieBuildingTileEntity";
import PeaPatchBuildingTileEntity from "../entities/buildings/PeaPatchBuildingTileEntity";
import PortBuildingTileEntity from "../entities/buildings/PortBuildingTileEntity";
import PremiumGoldMineBuildingTileEntity from "../entities/buildings/PremiumGoldMineBuildingTileEntity";
import PumpkinFarmBuildingTileEntity from "../entities/buildings/PumpkinFarmBuildingTileEntity";
import PumpkinFieldBuildingTileEntity from "../entities/buildings/PumpkinFieldBuildingTileEntity";
import RabbitFarmBuildingTileEntity from "../entities/buildings/RabbitFarmBuildingTileEntity";
import RaftBuildingTileEntity from "../entities/buildings/RaftBuildingTileEntity";
import RangersBuildingTileEntity from "../entities/buildings/RangersBuildingTileEntity";
import RationsSupplierBuildingTileEntity from "../entities/buildings/RationsSupplierBuildingTileEntity";
import RoofTileFactoryBuildingTileEntity from "../entities/buildings/RoofTileFactoryBuildingTileEntity";
import SaddlerBuildingTileEntity from "../entities/buildings/SaddlerBuildingTileEntity";
import SculptorBuildingTileEntity from "../entities/buildings/SculptorBuildingTileEntity";
import SeaWeedFarmBuildingTileEntity from "../entities/buildings/SeaWeedFarmBuildingTileEntity";
import SeaweedFieldBuildingTileEntity from "../entities/buildings/SeaweedFieldBuildingTileEntity";
import SettlementCastleBuildingTileEntity from "../entities/buildings/SettlementCastleBuildingTileEntity";
import ShallowSeaBigFishingBoatBuildingTileEntity from "../entities/buildings/ShallowBigSeaFishingBoatBuildingTileEntity";
import ShallowSeaFishingBoatBuildingTileEntity from "../entities/buildings/ShallowSeaFishingBoatBuildingTileEntity";
import ShallowSeaMediumFishTrapBuildingTileEntity from "../entities/buildings/ShallowSeaMediumFishTrapBuildingTileEntity";
import ShallowSeaPearlHunterBuildingTileEntity from "../entities/buildings/ShallowSeaPearlHunterBuildingTileEntity";
import ShallowSeaRocksLighthouseBuildingTileEntity from "../entities/buildings/ShallowSeaRocksLighthouseBuildingTileEntity";
import ShallowSeaSmallFishTrapBuildingTileEntity from "../entities/buildings/ShallowSeaSmallFishTrapBuildingTileEntity";
import ShepherdsLodgeBuildingTileEntity from "../entities/buildings/ShepherdsLodgeBuildingTileEntity";
import ShipyardBuildingTileEntity from "../entities/buildings/ShipyardBuildingTileEntity";
import ShoemakerWorkshopBuildingTileEntity from "../entities/buildings/ShoemakerWorkshopBuildingTileEntity";
import SilverMineBuildingTileEntity from "../entities/buildings/SilverMineBuildingTileEntity";
import SmallHousesBuildingTileEntity from "../entities/buildings/SmallHousesBuildingTileEntity";
import SmallStockpileBuildingTileEntity from "../entities/buildings/SmallStockpileBuildingTileEntity";
import SolsticeWindmillBuildingTileEntity from "../entities/buildings/SolsticeWindmillBuildingTileEntity";
import StablesBuildingTileEntity from "../entities/buildings/StablesBuildingTileEntity";
import StonemasonryDistrictBuildingTileEntity from "../entities/buildings/StonemasonryDistrictBuildingTileEntity";
import StoneQuarryBuildingTileEntity from "../entities/buildings/StoneQuarryBuildingTileEntity";
import StorageOverseerBuildingTileEntity from "../entities/buildings/StorageOverseerBuildingTileEntity";
import SupplyCaravanBuildingTileEntity from "../entities/buildings/SupplyCaravanBuildingTileEntity";
import SupplyCartBuildingTileEntity from "../entities/buildings/SupplyCartBuildingTileEntity";
import TailorsWorkshopBuildingTileEntity from "../entities/buildings/TailorsWorkshopBuildingTileEntity";
import TanneryBuildingTileEntity from "../entities/buildings/TanneryBuildingTileEntity";
import TaxOfficeBuildingTileEntity from "../entities/buildings/TaxOfficeBuildingTileEntity";
import TempleBuildingTileEntity from "../entities/buildings/TempleBuildingTileEntity";
import TollHouseBuildingTileEntity from "../entities/buildings/TollHouseBuildingTileEntity";
import ToolmakerBuildingTileEntity from "../entities/buildings/ToolmakerBuildingTileEntity";
import ToymakersWorkshopBuildingTileEntity from "../entities/buildings/ToymakersWorkshopBuildingTileEntity";
import TurkeyFarmBuildingTileEntity from "../entities/buildings/TurkeyFarmBuildingTileEntity";
import UniversalWarehouseBuildingTileEntity from "../entities/buildings/UniversalWarehouseBuildingTileEntity";
import UniversityBuildingTileEntity from "../entities/buildings/UniversityBuildingTileEntity";
import WarehouseBuildingTileEntity from "../entities/buildings/WarehouseBuildingTileEntity";
import WaterMillBuildingTileEntity from "../entities/buildings/WaterMillBuildingTileEntity";
import WaterSawMillBuildingTileEntity from "../entities/buildings/WaterSawMillBuildingTileEntity";
import WheatFarmBuildingTileEntity from "../entities/buildings/WheatFarmBuildingTileEntity";
import WheatFieldBuildingTileEntity from "../entities/buildings/WheatFieldBuildingTileEntity";
import { type FrameName } from "../entities/config";
import type TileEntity from "../entities/TileEntity";
import type TileRepository from "../TileRepository";

const map = new Map<FrameName, typeof TileEntity>();
map.set(
	SettlementCastleBuildingTileEntity.frameName,
	SettlementCastleBuildingTileEntity,
);
map.set(
	GatherersHutBuildingTileEntity.frameName,
	GatherersHutBuildingTileEntity,
);
map.set(LumberMillBuildingTileEntity.frameName, LumberMillBuildingTileEntity);
map.set(SmallHousesBuildingTileEntity.frameName, SmallHousesBuildingTileEntity);
map.set(WheatFarmBuildingTileEntity.frameName, WheatFarmBuildingTileEntity);
map.set(GoldMineBuildingTileEntity.frameName, GoldMineBuildingTileEntity);
map.set(
	PremiumGoldMineBuildingTileEntity.frameName,
	PremiumGoldMineBuildingTileEntity,
);
map.set(StoneQuarryBuildingTileEntity.frameName, StoneQuarryBuildingTileEntity);
map.set(BakeryBuildingTileEntity.frameName, BakeryBuildingTileEntity);
map.set(
	IndustrialLumberMillBuildingTileEntity.frameName,
	IndustrialLumberMillBuildingTileEntity,
);
map.set(ShipyardBuildingTileEntity.frameName, ShipyardBuildingTileEntity);
map.set(
	ShallowSeaFishingBoatBuildingTileEntity.frameName,
	ShallowSeaFishingBoatBuildingTileEntity,
);
map.set(
	DeepSeaFishingBoatBuildingTileEntity.frameName,
	DeepSeaFishingBoatBuildingTileEntity,
);
map.set(TollHouseBuildingTileEntity.frameName, TollHouseBuildingTileEntity);
map.set(ClayPitBuildingTileEntity.frameName, ClayPitBuildingTileEntity);
map.set(
	SmallStockpileBuildingTileEntity.frameName,
	SmallStockpileBuildingTileEntity,
);
map.set(IronMineBuildingTileEntity.frameName, IronMineBuildingTileEntity);
map.set(FurnaceBuildingTileEntity.frameName, FurnaceBuildingTileEntity);
map.set(MillBuildingTileEntity.frameName, MillBuildingTileEntity);
map.set(OxenStableBuildingTileEntity.frameName, OxenStableBuildingTileEntity);
map.set(BlacksmithBuildingTileEntity.frameName, BlacksmithBuildingTileEntity);
map.set(MarketBuildingTileEntity.frameName, MarketBuildingTileEntity);
map.set(
	ShallowSeaSmallFishTrapBuildingTileEntity.frameName,
	ShallowSeaSmallFishTrapBuildingTileEntity,
);
map.set(
	ShallowSeaMediumFishTrapBuildingTileEntity.frameName,
	ShallowSeaMediumFishTrapBuildingTileEntity,
);
map.set(FoundryBuildingTileEntity.frameName, FoundryBuildingTileEntity);
map.set(WarehouseBuildingTileEntity.frameName, WarehouseBuildingTileEntity);
map.set(
	UniversalWarehouseBuildingTileEntity.frameName,
	UniversalWarehouseBuildingTileEntity,
);
map.set(ToolmakerBuildingTileEntity.frameName, ToolmakerBuildingTileEntity);
map.set(ArmoryBuildingTileEntity.frameName, ArmoryBuildingTileEntity);
map.set(BarracksBuildingTileEntity.frameName, BarracksBuildingTileEntity);
map.set(OutpostBuildingTileEntity.frameName, OutpostBuildingTileEntity);
map.set(HealersHutBuildingTileEntity.frameName, HealersHutBuildingTileEntity);
map.set(
	HauntedMansionBuildingTileEntity.frameName,
	HauntedMansionBuildingTileEntity,
);
map.set(CorsairShipBuildingTileEntity.frameName, CorsairShipBuildingTileEntity);
map.set(
	HuntersLodgeBuildingTileEntity.frameName,
	HuntersLodgeBuildingTileEntity,
);
map.set(TanneryBuildingTileEntity.frameName, TanneryBuildingTileEntity);
map.set(
	TailorsWorkshopBuildingTileEntity.frameName,
	TailorsWorkshopBuildingTileEntity,
);
map.set(
	LargeStoneQuarryBuildingTileEntity.frameName,
	LargeStoneQuarryBuildingTileEntity,
);
map.set(
	MediumHousesBuildingTileEntity.frameName,
	MediumHousesBuildingTileEntity,
);
map.set(SilverMineBuildingTileEntity.frameName, SilverMineBuildingTileEntity);
map.set(
	CountryHouseBuildingTileEntity.frameName,
	CountryHouseBuildingTileEntity,
);
map.set(PumpkinFarmBuildingTileEntity.frameName, PumpkinFarmBuildingTileEntity);
map.set(BigShipyardBuildingTileEntity.frameName, BigShipyardBuildingTileEntity);
map.set(
	FishermansHutBuildingTileEntity.frameName,
	FishermansHutBuildingTileEntity,
);
map.set(LighthouseBuildingTileEntity.frameName, LighthouseBuildingTileEntity);
map.set(
	ShallowSeaRocksLighthouseBuildingTileEntity.frameName,
	ShallowSeaRocksLighthouseBuildingTileEntity,
);
map.set(
	LargeClayPitBuildingTileEntity.frameName,
	LargeClayPitBuildingTileEntity,
);
map.set(GemsMineBuildingTileEntity.frameName, GemsMineBuildingTileEntity);
map.set(
	LivestockFarmBuildingTileEntity.frameName,
	LivestockFarmBuildingTileEntity,
);
map.set(UniversityBuildingTileEntity.frameName, UniversityBuildingTileEntity);
map.set(
	AdvancedIronMineBuildingTileEntity.frameName,
	AdvancedIronMineBuildingTileEntity,
);
map.set(
	HillsScoutTowerBuildingTileEntity.frameName,
	HillsScoutTowerBuildingTileEntity,
);
map.set(
	MountainsScoutTowerBuildingTileEntity.frameName,
	MountainsScoutTowerBuildingTileEntity,
);
map.set(BreweryBuildingTileEntity.frameName, BreweryBuildingTileEntity);
map.set(InnBuildingTileEntity.frameName, InnBuildingTileEntity);
map.set(
	ShoemakerWorkshopBuildingTileEntity.frameName,
	ShoemakerWorkshopBuildingTileEntity,
);
map.set(PatisserieBuildingTileEntity.frameName, PatisserieBuildingTileEntity);
map.set(GuardTowerBuildingTileEntity.frameName, GuardTowerBuildingTileEntity);
map.set(
	CarpentryDistrictBuildingTileEntity.frameName,
	CarpentryDistrictBuildingTileEntity,
);
map.set(
	StonemasonryDistrictBuildingTileEntity.frameName,
	StonemasonryDistrictBuildingTileEntity,
);
map.set(TaxOfficeBuildingTileEntity.frameName, TaxOfficeBuildingTileEntity);
map.set(LargeHousesBuildingTileEntity.frameName, LargeHousesBuildingTileEntity);
map.set(
	ArtisanSmithBuildingTileEntity.frameName,
	ArtisanSmithBuildingTileEntity,
);
map.set(
	WaterSawMillBuildingTileEntity.frameName,
	WaterSawMillBuildingTileEntity,
);
map.set(
	FishingVillageBuildingTileEntity.frameName,
	FishingVillageBuildingTileEntity,
);
map.set(SculptorBuildingTileEntity.frameName, SculptorBuildingTileEntity);
map.set(
	RoofTileFactoryBuildingTileEntity.frameName,
	RoofTileFactoryBuildingTileEntity,
);
map.set(
	IndustrialFoundryBuildingTileEntity.frameName,
	IndustrialFoundryBuildingTileEntity,
);
map.set(ArenaBuildingTileEntity.frameName, ArenaBuildingTileEntity);
map.set(
	MountainBellowsBuildingTileEntity.frameName,
	MountainBellowsBuildingTileEntity,
);
map.set(WaterMillBuildingTileEntity.frameName, WaterMillBuildingTileEntity);
map.set(BrickyardBuildingTileEntity.frameName, BrickyardBuildingTileEntity);
map.set(FletcherBuildingTileEntity.frameName, FletcherBuildingTileEntity);
map.set(
	ArcheryRangeBuildingTileEntity.frameName,
	ArcheryRangeBuildingTileEntity,
);
map.set(
	ShallowSeaPearlHunterBuildingTileEntity.frameName,
	ShallowSeaPearlHunterBuildingTileEntity,
);
map.set(
	DeepSeaPearlHunterBuildingTileEntity.frameName,
	DeepSeaPearlHunterBuildingTileEntity,
);
map.set(SeaWeedFarmBuildingTileEntity.frameName, SeaWeedFarmBuildingTileEntity);
map.set(TurkeyFarmBuildingTileEntity.frameName, TurkeyFarmBuildingTileEntity);
map.set(MintBuildingTileEntity.frameName, MintBuildingTileEntity);
map.set(PortBuildingTileEntity.frameName, PortBuildingTileEntity);
map.set(BathHouseBuildingTileEntity.frameName, BathHouseBuildingTileEntity);
map.set(
	GoldProspectorBuildingTileEntity.frameName,
	GoldProspectorBuildingTileEntity,
);
map.set(
	DarkwoodLumberMillBuildingTileEntity.frameName,
	DarkwoodLumberMillBuildingTileEntity,
);
map.set(
	ToymakersWorkshopBuildingTileEntity.frameName,
	ToymakersWorkshopBuildingTileEntity,
);
map.set(WheatFieldBuildingTileEntity.frameName, WheatFieldBuildingTileEntity);
map.set(HopsFieldBuildingTileEntity.frameName, HopsFieldBuildingTileEntity);
map.set(CattleRangeBuildingTileEntity.frameName, CattleRangeBuildingTileEntity);
map.set(
	CattleRangeSpecialBuildingTileEntity.frameName,
	CattleRangeSpecialBuildingTileEntity,
);
map.set(
	PumpkinFieldBuildingTileEntity.frameName,
	PumpkinFieldBuildingTileEntity,
);
map.set(
	SeaweedFieldBuildingTileEntity.frameName,
	SeaweedFieldBuildingTileEntity,
);
map.set(ApiaryBuildingTileEntity.frameName, ApiaryBuildingTileEntity);
map.set(CandlemakerBuildingTileEntity.frameName, CandlemakerBuildingTileEntity);
map.set(SaddlerBuildingTileEntity.frameName, SaddlerBuildingTileEntity);
map.set(StablesBuildingTileEntity.frameName, StablesBuildingTileEntity);
map.set(TempleBuildingTileEntity.frameName, TempleBuildingTileEntity);
map.set(
	ShallowSeaBigFishingBoatBuildingTileEntity.frameName,
	ShallowSeaBigFishingBoatBuildingTileEntity,
);
map.set(
	DeepSeaBigFishingBoatBuildingTileEntity.frameName,
	DeepSeaBigFishingBoatBuildingTileEntity,
);
map.set(ApothecaryBuildingTileEntity.frameName, ApothecaryBuildingTileEntity);
map.set(BanquetBuildingTileEntity.frameName, BanquetBuildingTileEntity);
map.set(
	MinstrelsPodiumBuildingTileEntity.frameName,
	MinstrelsPodiumBuildingTileEntity,
);
map.set(
	MonolithCircleBuildingTileEntity.frameName,
	MonolithCircleBuildingTileEntity,
);
map.set(RaftBuildingTileEntity.frameName, RaftBuildingTileEntity);
map.set(BottletrapBuildingTileEntity.frameName, BottletrapBuildingTileEntity);
map.set(FortressBuildingTileEntity.frameName, FortressBuildingTileEntity);
map.set(RabbitFarmBuildingTileEntity.frameName, RabbitFarmBuildingTileEntity);
map.set(
	LuckyCauldronBuildingTileEntity.frameName,
	LuckyCauldronBuildingTileEntity,
);
map.set(
	HillsBlastFurnaceBuildingTileEntity.frameName,
	HillsBlastFurnaceBuildingTileEntity,
);
map.set(
	MountainsBlastFurnaceBuildingTileEntity.frameName,
	MountainsBlastFurnaceBuildingTileEntity,
);
map.set(
	StorageOverseerBuildingTileEntity.frameName,
	StorageOverseerBuildingTileEntity,
);
map.set(
	ArmamentsTraderBuildingTileEntity.frameName,
	ArmamentsTraderBuildingTileEntity,
);
map.set(
	HillsLookoutTowerBuildingTileEntity.frameName,
	HillsLookoutTowerBuildingTileEntity,
);
map.set(
	MountainsLookoutTowerBuildingTileEntity.frameName,
	MountainsLookoutTowerBuildingTileEntity,
);
map.set(PeaPatchBuildingTileEntity.frameName, PeaPatchBuildingTileEntity);
map.set(ManorBuildingTileEntity.frameName, ManorBuildingTileEntity);
map.set(
	LargeBreweryBuildingTileEntity.frameName,
	LargeBreweryBuildingTileEntity,
);
map.set(
	EnkindledHouseholdBuildingTileEntity.frameName,
	EnkindledHouseholdBuildingTileEntity,
);
map.set(
	FireFestivalPyreBuildingTileEntity.frameName,
	FireFestivalPyreBuildingTileEntity,
);
map.set(
	BountifulMarketplaceBuildingTileEntity.frameName,
	BountifulMarketplaceBuildingTileEntity,
);
map.set(
	SolsticeWindmillBuildingTileEntity.frameName,
	SolsticeWindmillBuildingTileEntity,
);
map.set(HuntingCampBuildingTileEntity.frameName, HuntingCampBuildingTileEntity);
map.set(
	HighlandHunterBuildingTileEntity.frameName,
	HighlandHunterBuildingTileEntity,
);
map.set(
	ShepherdsLodgeBuildingTileEntity.frameName,
	ShepherdsLodgeBuildingTileEntity,
);
map.set(
	RationsSupplierBuildingTileEntity.frameName,
	RationsSupplierBuildingTileEntity,
);
map.set(
	MilitaryAcademyBuildingTileEntity.frameName,
	MilitaryAcademyBuildingTileEntity,
);
map.set(MilitiaBuildingTileEntity.frameName, MilitiaBuildingTileEntity);
map.set(SupplyCartBuildingTileEntity.frameName, SupplyCartBuildingTileEntity);
map.set(
	SupplyCaravanBuildingTileEntity.frameName,
	SupplyCaravanBuildingTileEntity,
);
map.set(ArchersBuildingTileEntity.frameName, ArchersBuildingTileEntity);
map.set(
	LightCavalryBuildingTileEntity.frameName,
	LightCavalryBuildingTileEntity,
);
map.set(RangersBuildingTileEntity.frameName, RangersBuildingTileEntity);
map.set(CommandPostBuildingTileEntity.frameName, CommandPostBuildingTileEntity);

// TODO: rename + rename file
export const getBuildingTileEntity = (
	type: FrameName,
): typeof TileEntity | null => (map.has(type) ? map.get(type)! : null);

// TODO: rename + rename file
export const createBuildingTileEntity = (
	type: FrameName,
	coordinates: TileCoordinates,
	tilerepo: TileRepository,
): TileEntity | null => {
	const entity = getBuildingTileEntity(type);
	return entity ? new entity(coordinates, tilerepo) : null;
};
